export function waitFor(milliseconds: number): Promise<unknown> {
  const newWait = new Promise(function (resolve) {
    setTimeout(resolve, milliseconds);
  });

  return newWait;
}
